"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAGBrand = void 0;
var TAGBrand;
(function (TAGBrand) {
    TAGBrand["Enterprise"] = "enterprise";
    TAGBrand["AspenDental"] = "aspendental";
    TAGBrand["Motto"] = "motto";
    TAGBrand["WellNow"] = "wellnow";
    TAGBrand["TeamTAG"] = "teamTag";
    TAGBrand["AZPetVet"] = "azPetVet";
    TAGBrand["Chapter"] = "chapter";
    TAGBrand["ClearChoice"] = "clearchoice";
    TAGBrand["LivWellNow"] = "livWellNow";
    TAGBrand["Lovet"] = "lovet";
})(TAGBrand || (exports.TAGBrand = TAGBrand = {}));
